import { Link } from '@mui/material';

interface OpenPhoneNumberProps {
	number?: string | number;
}

const OpenPhoneNumber = (props: OpenPhoneNumberProps) => {
	const { number } = props;

	return <Link href={`tel:${number}`}>{number}</Link>;
};

export default OpenPhoneNumber;
